import React, { Component } from 'react';
import { Modal, Button, Form, Input, Tooltip } from 'antd';
import _ from "lodash";
import { connect } from 'dva';
import FormCreate from '../../../../../../../components/FormCreate/index';
import ListPage from '../../../../../../../components/ListPage';
import TreeSelectChannel from '../../../../ArticlePublished/components/TreeSelectChannel';
import { getAppCode } from '../../../../utils/utils';
import { convertData, getLabelStrData } from '../../../../utils/convertData';
import styles from './index.less';

const { ListTable } = ListPage;

const {
  FormTitle,
} = FormCreate;
@Form.create()

@connect(({ courseManage }) => {
  return {
    ...courseManage,
  };
})


class CourseContentModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      totalElements: 0,
      visible: false,
      alreadyPushList: {},
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: '',
        labelId: 0,
        newsTypes: '2',
      },
      treeChannelData: [],
      chooseCourseData: [],


      currentData: {},
      editTitleVisible: false,
      editTitlData: {},
      materialIdsList: []

    };

  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchChannelList();
    this.fetchNewsManagerList(params);
    this.setColumns()
  }


  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'newstype',
        key: 'newstype',
        width: 100,
        render: () => {
          return '视频素材';
        },
      },
    ];
    this.setState({ columns });
  };

  fetchNewsManagerList = params => {
    const { dispatch } = this.props;
    const { alreadyPushList } = this.state;
    dispatch({
      type: 'courseManage/fetchNewsManagerList',
      params,
    })
      .then(res => {

        this.setState({
          dataSource: getLabelStrData(res, alreadyPushList),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {

      });
  };

  setChannelId = id => {
    const { params } = this.state;
    this.setState({ params: { ...params, page: 1, channelId: id } });
  };


  fetchChannelList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'courseManage/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = [{ value: 0, label: '全部栏目', children: convertData(res || []) }];
        const channelList = convertData(res || []);
        channelList.unshift({ value: 0, label: '全部', children: [] });

        this.setState({
          // channelList,
          treeChannelData: data,
        });
      })
      .catch(() => {
      });
  };

  onOk = () => {
    const { chooseCourse, chapterList, copyContent } = this.props;
    const { chooseCourseData, currentData } = this.state;

    chapterList.forEach(item => {
      if (item.id === currentData.id) {
        const { chapterMaterial } = item
        // eslint-disable-next-line no-param-reassign
        item.chapterMaterial = chapterMaterial.concat(chooseCourseData)
      }
    })

    chooseCourse(chapterList)
    copyContent(chapterList)

    this.setState({
      visible: false
    })
  }

  chooseCourseData = (selectedRowKeys, selectedRows) => {
    const { chooseCourseData } = this.state;
    const data = []
    selectedRows.forEach(item => {
      const { id, title, content, coverPicUrl1, coverPicFileId } = item
      data.push({
        materialId: id,
        materialName: title,
        content,
        coverPicUrl1,
        coverPicFileId,
      })
    })

    const concatData = [...chooseCourseData, ...data];

    this.setState({
      chooseCourseData: _.uniqBy(concatData, 'materialId'),

    })
  }

  search = e => {
    e.preventDefault();
    const searchData = e.target.value
    const { params } = this.state;
    const tempParams = {
      ...params,
      title: searchData ? encodeURIComponent(searchData) : '',
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsManagerList(tempParams);
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsManagerList(tempParams);
  };

  selectMatter = currentData => {

    const { chapterMaterial = [] } = currentData;

    const arr = []
    chapterMaterial.forEach(item => {
      arr.push(item.materialId)
    })

    this.setState({
      visible: true,
      currentData,
      materialIdsList: arr
    })
  }

  handerOption = (type, index, item) => {

    const { chapterList, chooseCourse } = this.props;
    const { chapterMaterial } = item

    if (type === 'up') {
      chapterMaterial.splice(index - 1, 0, (chapterMaterial[index]))
      // 删除后一项
      chapterMaterial.splice(index + 1, 1)
    }

    if (type === 'down') {
      chapterMaterial.splice(index + 2, 0, (chapterMaterial[index]))
      // 删除前一项
      chapterMaterial.splice(index, 1)
    }

    if (type === 'delete') {
      chapterMaterial.splice(index, 1);
    }

    chapterList.forEach(subitem => {
      if (subitem.id === item.id) {
        // eslint-disable-next-line no-param-reassign
        subitem = item
      }
    })

    chooseCourse(JSON.parse(JSON.stringify(chapterList)))

  }

  editTitle = (item) => {
    const { form } = this.props;
    const { setFieldsValue } = form;
    this.setState({
      editTitleVisible: true,
      editTitlData: item
    })
    setFieldsValue({
      chapterName: item.chapterName
    });
  }

  deleteList = (item, listIndex) => {
    const { chapterList, chooseCourse } = this.props;

    Modal.confirm({
      title: '确认删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        chapterList.splice(listIndex, 1);
        chooseCourse(JSON.parse(JSON.stringify(chapterList)))

      },

    });

  }

  handleEditTitleOk = () => {

    const { editTitlData } = this.state;

    const { form, chapterList, chooseCourse } = this.props;
    const { validateFields, getFieldsValue } = form;
    const values = getFieldsValue();

    validateFields(err => {
      if (!err) {

        editTitlData.chapterName = values.chapterName;

        chapterList.forEach(subitem => {
          if (subitem.id === editTitlData.id) {
            // eslint-disable-next-line no-param-reassign
            subitem = editTitlData
          }
        })

        chooseCourse(JSON.parse(JSON.stringify(chapterList)))

        this.setState({
          editTitleVisible: false
        })
      }
    });
  }


  render() {
    const { visible, treeChannelData, params, totalElements, columns, dataSource, editTitleVisible, editTitlData, materialIdsList } = this.state;
    const { chapterName } = editTitlData;
    const { page } = params;
    const { chapterList, addChapterCourse, form } = this.props;
    const { getFieldsValue } = form;
    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => this.chooseCourseData(selectedRowKeys, selectedRows),
        // eslint-disable-next-line consistent-return
        getCheckboxProps: record => {

          if (materialIdsList.indexOf(record.id) > -1) {
            return { disabled: true }
          }

        }
      },
      onPageChange: this.changePage,
    };

    const titleProps = {
      form,
      value: chapterName,
      label: '开课主题',
      keyName: 'chapterName',
      isRequired: true,
      maxLength: 20,
      suffix: `${(getFieldsValue().chapterName?.length) || chapterName?.length || 0}/20`,
    };
    const customerFormItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };


    return (
      <>
        <Button onClick={addChapterCourse}>新增章节</Button>
        {
          chapterList.map((item, listIndex) => {
            const { chapterMaterial, cannotDelete } = item;

            return (
              <div className={styles.listWrap}>
                <div className='list'>
                  <div className='title-wrap'>
                    <div className='title'>
                      {item.chapterName}
                      <img src='https://s.xiaoyuanhao.com/file/0cc0418f-1a69-4851-bf66-1a6d98f64689.svg' alt='' onClick={() => this.editTitle(item)} />
                    </div>
                    <Button type="primary" onClick={() => this.selectMatter(item)}>+ 选择素材</Button>
                  </div>

                  {
                    chapterMaterial.length === 0 ? (
                      <div className='content-wrap'>
                        <div className='choose-tips'>请添加至少一个素材内容</div>
                      </div>
                    ) : (
                        // eslint-disable-next-line react/jsx-indent
                        <>
                          {
                            chapterMaterial.map((capter, index) => {
                              const length = chapterMaterial && chapterMaterial.length;
                              return (
                                <div className='content-wrap'>
                                  <div className='title'>
                                    <span className='img-wrap'>
                                      <span> {index + 1}</span>

                                      <img src='https://s.xiaoyuanhao.com/file/098b96c6-d701-4a0a-9aa6-47cd924ff337.svg' alt='' />
                                    </span>

                                    <span className='materialName'> {capter.materialName}</span>

                                  </div>
                                  <div className='options'>
                                    {
                                      index !== 0 && <><span onClick={() => this.handerOption('up', index, item)}>上移</span><i className='line' /></>
                                    }
                                    {
                                      index < length - 1 && <><span onClick={() => this.handerOption('down', index, item)}>下移</span><i className='line' /></>
                                    }
                                    {
                                      !capter.cannotDelete && <span onClick={() => this.handerOption('delete', index, item)}>移除</span>
                                    }
                                  </div>
                                </div>
                              )
                            })
                          }
                        </>
                      )
                  }
                </div>
                {
                  (!cannotDelete && chapterList.length > 1) && (
                    <div className='delete-img-wrap' onClick={() => this.deleteList(item, listIndex)}>
                      <img src='https://s.xiaoyuanhao.com/file/56677f89-38a3-44ba-b1e8-7e6d40df41c9.svg' alt='' />
                    </div>
                  )
                }
              </div>
            )

          })
        }
        <div className='tips'>素材上限: 最多支持添加300个素材 <br /> 完成条件: 学员累计学习时长达到管理员设置的时长要求</div>
        {
          visible && (
            <Modal
              width={720}
              className={styles['course-content-modal']}
              centered
              title='课程内容选择'
              visible={visible}
              onOk={() => this.onOk()}
              onCancel={() => this.setState({
                visible: false
              })}
            >
              <section className='search-area'>
                <div>搜索：</div>
                <Input placeholder="请搜索" onPressEnter={this.search} />
              </section>
              <section className="table-area">
                <div>
                  <TreeSelectChannel
                    channelList={treeChannelData}
                    params={params}
                    fetchPublishList={this.fetchNewsManagerList}
                    setChannelId={this.setChannelId}
                  />
                </div>
                <div>
                  <ListTable {...tableProps} />
                </div>
              </section>
            </Modal>
          )

        }

        <Modal
          title="修改章节名称"
          visible={editTitleVisible}
          onOk={this.handleEditTitleOk}
          onCancel={() => {
            this.setState({
              editTitleVisible: false
            })
          }}
        >
          <FormCreate customerFormItemLayout={customerFormItemLayout}>
            <FormTitle {...titleProps} />
          </FormCreate>

        </Modal>
      </>

    );
  }
}

export default CourseContentModal;
